import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import withStyles from '@mui/styles/withStyles';
import withTheme from '@mui/styles/withTheme';
import { compose, Query } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import Badge from '@mui/material/Badge';
import { getUser } from '../../utils/sessions';
import { dateTimeToString } from '../../utils/date';
import Grid from '../layout/Grid';
import { BellIcon, CloseIcon, DeleteIcon } from '../IconIndex';
import {
    clearMemberNotificationsFunc,
    getUserNotificationsQuery,
    updateNotificationMembersFunc
} from './GetSaveNotification';
import { getMyClient } from '../../utils/apollo';
import Tooltip from '@mui/material/Tooltip';
import { GQL_REFETCH_30S, subscribe } from '../../utils/subscriptions.js';
import { Grow } from '@mui/material';

class NotificationsPopover extends Component {
    state = {
        loading: false,
        loadingNotificationId: null,
        open: false,
        loadedDate: dateTimeToString(moment('2012-12-12')),
        seenDate: false
    };
    audio = new Audio('/service-bell_daniel_simion.mp3');
    // audioContext = new (window.AudioContext || window.webkitAudioContext)();
    refTarget = React.createRef();

    constructor(props) {
        super(props);
        this.notificationQueryRef = React.createRef();
        subscribe(this.notificationQueryRef, GQL_REFETCH_30S);
    }

    static getDerivedStateFromProps(props, state) {
        let seenDate = window.localStorage.getItem('notificationSeenDate');
        if (!seenDate) seenDate = dateTimeToString(moment('2012-12-21')); // the end of the world?!
        if (seenDate !== state.seenDate) return { seenDate };
        return null;
    }

    render() {
        const user = getUser();
        const { classes } = this.props;
        const { seenDate, loadingNotificationId } = this.state;
        return (
            <Query
                client={getMyClient()}
                query={getUserNotificationsQuery}
                variables={{
                    userId: user.ID,
                    limit: 99,
                    offset: 0
                }}
                ref={this.notificationQueryRef}
            >
                {({ data, loading, error }) => {
                    const { readNotifications } = data || false;
                    const notificationCount = readNotifications
                        ? readNotifications.edges.length + (!!readNotifications.pageInfo.hasNextPage && '+')
                        : 0;
                    const latestDate = (notificationCount && readNotifications.edges[0].node.Created) || null;
                    const ss = Number(notificationCount) === 1 ? '' : 's';
                    const latestUnread =
                        readNotifications && readNotifications.edges.find(({ node }) => node.Created > seenDate);
                    const latestUnreadID = (latestUnread && latestUnread.node.ID) || null;
                    const isDeleting = latestUnreadID && loadingNotificationId !== latestUnreadID;
                    return (
                        <Fragment>
                            <Grow in={latestUnreadID && loadingNotificationId !== latestUnreadID}>
                                <div
                                    title="Clear this notification"
                                    role="button"
                                    tabIndex="0"
                                    className={classes.latestInHeader}
                                    onKeyDown={e =>
                                        !loading &&
                                        ['Enter', ' '].includes(e.key) &&
                                        this.setNotificationToRead(0, latestUnread)
                                    }
                                    onClick={() => !loading && this.setNotificationToRead(0, latestUnread)}
                                >
                                    {!!latestUnread && this.renderNotification(latestUnread, isDeleting)}
                                </div>
                            </Grow>
                            <Tooltip title={'You have ' + notificationCount + ' notification' + ss + '.'}>
                                {this.renderNotificationsButton(notificationCount, latestDate)}
                            </Tooltip>
                            {this.renderPopOver(notificationCount, readNotifications, loading || error, latestDate)}
                        </Fragment>
                    );
                }}
            </Query>
        );
    }

    renderNotificationsButton(notificationCount, latestDate) {
        const { classes } = this.props;
        const { seenDate } = this.state;

        if (latestDate > seenDate) {
            this.audio.currentTime = 0;
            // this.audio.play();
        }

        return (
            <Badge
                color={latestDate > seenDate ? 'secondary' : 'primary'}
                badgeContent={notificationCount}
                classes={{ badge: classes.notificationsBadge }}
                onClick={() => {
                    this.openPopup(latestDate);
                }}
            >
                <IconButton className={classes.notificationsButton} ref={this.refTarget} size="large">
                    <BellIcon
                        color="disabled"
                        className={latestDate > seenDate ? classes.notificationsIconRing : classes.notificationsIcon}
                    />
                </IconButton>
            </Badge>
        );
    }

    renderPopOver(notificationCount, readNotifications, loadingAll) {
        const { classes } = this.props;
        const { open, loadingNotificationId, loading } = this.state;

        const ss = Number(notificationCount) === 1 ? '' : 's';
        return (
            <Popover
                anchorEl={this.refTarget.current || undefined}
                open={open}
                onClose={() => this.onClose()}
                anchorReference="anchorEl"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div className={classes.paper}>
                    <div className={classes.headline}>
                        <Typography variant="h5" id="modal-title">
                            {notificationCount || ''} Notification{ss}
                        </Typography>
                    </div>
                    <div
                        className={classes.paperScroll}
                        style={loading && !loadingNotificationId ? { pointerEvents: 'none', opacity: 0.5 } : null}
                    >
                        {loadingAll && !readNotifications
                            ? this.renderLoading()
                            : this.renderNotifications(readNotifications)}
                    </div>
                    <div style={{ clear: 'both', textAlign: 'right' }}>
                        {!!notificationCount && (
                            <Button
                                className={classes.clearButton}
                                onClick={this.onClearAll}
                                size="small"
                                disabled={loading}
                            >
                                <DeleteIcon />
                                &nbsp;Dismiss All
                            </Button>
                        )}
                        <Button className={classes.closeButton} onClick={this.onClose} size="small">
                            <CloseIcon />
                            &nbsp;Close
                        </Button>
                    </div>
                </div>
            </Popover>
        );
    }

    renderLoading() {
        const { classes } = this.props;
        return (
            <div className={classes.paddedContent}>
                <span>Loading...</span>
                <span className={classes.loading}>
                    <CircularProgress />
                </span>
            </div>
        );
    }

    renderNotifications(Notifications) {
        const {
            classes,
            theme: { palette }
        } = this.props;
        const { loading, loadingNotificationId } = this.state;
        if (!Notifications) return null;
        return (
            <Fragment>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        {Notifications.edges.length === 0 ? (
                            <div className={classes.paddedContent}>
                                <p>You currently have no unread notifications.</p>
                                <div className={classes.chillax}>
                                    <Icon>emoji_food_beverage</Icon>
                                    <div>Come back later... ?</div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <ul className={classes.notificationsList}>
                                    {Notifications.edges.map((notification, i) => {
                                        const { letterCode } = { letterCode: 'X' };
                                        return (
                                            <li
                                                key={notification.node.ID}
                                                className={classes['officeTheme' + letterCode]}
                                                style={{
                                                    // borderTopColor: palette.contentForeground[letterCode],
                                                    borderLeftColor: palette.contentForeground[letterCode],
                                                    backgroundColor: palette.contentBackground[letterCode],
                                                    opacity:
                                                        loadingNotificationId === notification.node.ID ? '0.25' : null
                                                }}
                                            >
                                                {this.renderNotification(
                                                    notification,
                                                    loadingNotificationId === notification.node.ID
                                                )}

                                                {loadingNotificationId === notification.node.ID ? (
                                                    <span className={classes.clearLoading}>
                                                        <span className={classes.loading}>
                                                            <CircularProgress />
                                                        </span>
                                                    </span>
                                                ) : (
                                                    <span
                                                        className={classes.clearIcon}
                                                        title="Dismiss this notification"
                                                    >
                                                        <IconButton
                                                            onClick={() =>
                                                                !loading && this.setNotificationToRead(i, notification)
                                                            }
                                                            size="large"
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </span>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Fragment>
                        )}
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    renderNotification(notification, i = 0, loading = false) {
        const { classes } = this.props;
        const { TabURLSegment } = notification.node;
        const path = this.getNotificationURL(notification);
        return (
            <div
                title="Clear this notification"
                role="button"
                tabIndex="0"
                className={classes.notification}
                onKeyDown={e =>
                    !loading && ['Enter', ' '].includes(e.key) && this.setNotificationToRead(i, notification)
                }
                onClick={() => !loading && this.setNotificationToRead(i, notification)}
            >
                {!!TabURLSegment ? (
                    <a
                        href={path}
                        role="navigation"
                        tabIndex="0"
                        className={cx(classes.notificationTitle, 'button-base')}
                        title="Take me there"
                        onClick={e => {
                            e.preventDefault();
                            !loading && this.onClickNotification(i, notification);
                        }}
                        onKeyDown={e => {
                            e.stopPropagation();
                            !loading && ['Enter', ' '].includes(e.key) && this.onClickNotification(i, notification);
                        }}
                    >
                        {notification.node.Title}
                    </a>
                ) : (
                    <span className={classes.notificationTitle}>{notification.node.Title}</span>
                )}
                <span className={classes.notificationDescription}>
                    <br />
                    {moment(notification.node.Created).fromNow()}
                    {': '}
                    <span>{notification.node.Description}</span>
                </span>
            </div>
        );
    }

    setNotificationToRead(index, original) {
        const user = getUser();
        const notification = cloneDeep(original);
        const notifiedMember = notification.node.AssignedMembers.find(x => Number(x.ID) === Number(user.ID));

        notifiedMember._join.NotificationMembers.Read = notifiedMember._join.NotificationMembers.Read
            ? notifiedMember._join.NotificationMembers.Read
            : dateTimeToString(new Date());

        this.updateNotification(notification, original);
    }

    onClose = () => {
        const { onClose } = this.props;
        if (onClose) onClose();
        this.setState({ open: false }, async () =>
            this.updateLocalStorage()
        );
    };

    onClickNotification(index, notification) {
        this.setNotificationToRead(index, notification);
        this.goToNotification(notification);
        this.onClose();
    }

    goToNotification(notification) {
        const path = this.getNotificationURL(notification);
        if (!!path && path !== '') {
            const { history } = this.props;
            history.push(path);
        }
    }

    getNotificationURL(notification) {
        const { TabURLSegment } = notification.node;
        let path = TabURLSegment;
        // just use it
        return path;
    }

    updateNotification(notification, original, onSaved) {
        this.setState({ loading: true, loadingNotificationId: notification.node.ID }, async () =>
            await updateNotificationMembersFunc(notification, original).then(
                () => {
                    this.setState({ loading: false });
                    this.updateLocalStorage();
                    onSaved && onSaved();
                },
                error => this.onGqlError('Failed to update/reload notifications', error)
            ));
    }

    onClearAll = () => {
        this.setState({ loading: true }, async () =>
            await clearMemberNotificationsFunc().then(
                () => {
                    this.setState({ loading: false });
                    this.updateLocalStorage();
                },
                error => this.onGqlError('Failed to clear/reload notifications', error)
            ));
    };

    onGqlError(action, error) {
        console.error(action, error);
        this.setState({ loading: false, loadingNotificationId: null });
    }

    openPopup = latestDate => {
        this.setState({
            open: true,
            loadedDate: latestDate
        });
    };

    updateLocalStorage = () => {
        const { loadedDate } = this.state;
        window.localStorage.setItem('notificationSeenDate', loadedDate);
    };
}

const styles = ({ sizes, spacing, transitions, palette, breakpoints }) => ({
    root: {},
    buttonGroup: {
        marginTop: 12,
        clear: 'both',
        '& button': {
            marginRight: 12
        },
        '& button:last-child': {
            marginRight: 0
        }
    },
    headline: {
        padding: spacing(2),
        whiteSpace: 'pre'
    },
    paper: {
        width: 400,
        maxWidth: '100%',
        maxHeight: 'calc(100vh - 32px)',
        backgroundColor: '#fafafa'
    },
    paperScroll: {
        overflow: 'hidden',
        maxHeight: 'calc(100vh - 160px)',
        padding: 0,
        width: '100%',
        clear: 'both',
        background: '#fff'
    },
    selectButton: {
        marginRight: 10,
        marginTop: 15
    },
    notificationsBadge: {
        top: 12,
        right: 12,
        width: 24,
        height: 24,
        borderRadius: 32,
        pointerEvents: 'none'
    },
    notificationsButton: {
        //marginLeft: spacing.unit * 2
    },
    notificationsIcon: {
        fontSize: '1.75rem'
    },
    loading: {
        float: 'right',
        transform: 'scale(0.5)',
        width: 28
    },
    paddedContent: {
        margin: spacing(3)
    },
    notificationsList: {
        listStyle: 'none',
        maxHeight: 'calc(100vh - 160px)',
        margin: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        position: 'relative',
        padding: '0',
        '& > li': {
            borderStyle: 'solid',
            borderTopColor: '#CCC',
            borderBottomColor: '#CCC',
            borderRightColor: 'transparent',
            borderWidth: '1px 15px 0px 5px',
            display: 'flex',
            alignItems: 'center',
            transition: transitions.create(['border-width', 'box-shadow', 'background', 'transform'])
        },
        '& > li:last-child': {
            borderWidth: '1px 15px 1px 5px'
        },
        '& > li:hover': {
            borderLeftWidth: 15,
            borderRightWidth: 5,
            //boxShadow: '-2px 2px 2px 2px #888888',
            backgroundColor: 'white',
            zIndex: '1',
            '& button': {
                opacity: 1
            }
        },
        '& > li:active': {
            //transform:'translateX(205%)'// todo:make this transition away nicely
        }
    },
    latestInHeader: {
        textAlign: 'right',
        maxHeight: sizes.headerHeight,
        overflow: 'auto',
        marginRight: -6,
        lineHeight: 0.75,
        [breakpoints.down('sm')]: {
            // too big to show
            display: 'none'
        },
        '& > div': {
            cursor: 'pointer',
            padding: '2px 0',
            width: 'unset'
        }
    },
    notification: {
        width: 'calc(100% - 43px)',
        display: 'inline-block',
        padding: 16,
        paddingRight: 0,
        overflow: 'hidden'
    },

    notificationTitle: {
        fontSize: '14px',
        color: 'black',
        textDecoration: 'none',
        '&.button-base': {
            cursor: 'pointer',
            color: '#333',
            fontWeight: 500,
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    },

    notificationDescription: {
        fontSize: '12px',
        fontWeight: 300,
        color: '#888888',
        '& > span': {
            color: 'black'
        }
    },

    clearIcon: {
        margin: 15,
        display: 'inline-block',
        position: 'absolute',
        right: 0,

        '& > button': {
            height: '28px',
            width: '28px',
            padding: 0,
            color: '#666',
            opacity: 0.125,
            '&:hover': {
                color: palette.action.destroy
            }
        },
        '& > button:first-child > span:first-child > svg': {
            height: '18px',
            width: '18px'
        }
    },

    clearLoading: {
        margin: '10px 15px',
        display: 'inline-block',
        position: 'absolute',
        right: 0
    },

    clearButton: {
        '& svg': { fontSize: '18px' },
        float: 'left',
        color: palette.action.destroy,
        margin: spacing(1)
    },
    closeButton: {
        '& svg': { fontSize: '18px' },
        margin: spacing(1)
    },
    chillax: {
        position: 'relative',
        height: 96,
        overflow: 'hidden',
        margin: '0 10% 64px',
        borderBottom: '8px solid #e9e9e9',
        '& > span': {
            fontSize: 96,
            transition: '2s ease-in-out',
            left: 0,
            bottom: -26,
            position: 'absolute',
            color: palette.primary.main
        },
        '& > div': {
            opacity: 0,
            left: 'calc(100% - 26px)',
            transition: 'opacity 0',
            position: 'absolute',
            bottom: 70,
            fontSize: '0.8em',
            whiteSpace: 'pre',
            color: palette.secondary.main
        },
        '&:hover > span': { color: palette.secondary.main, left: 'calc(100% - 96px)', cursor: 'grab' },
        '&:hover > span:active': { cursor: 'grabbing' },
        '&:hover > div': { opacity: 1, left: 0, transition: '1s ease-in-out 1.125s' }
    },

    notificationsIconRing: {
        fontSize: '1.75rem',
        animation: '$swing 0.6s ease infinite'
    },

    '@keyframes swing': {
        '0%': { transform: 'rotateZ(0)' },
        '25%': { transform: 'rotateZ(25deg)' },
        '50%': { transform: 'rotateZ(-15deg)' },
        '75%': { transform: 'rotateZ(10deg)' },
        '100%': { transform: 'rotateZ(0)' }
    }
});

// prettier-ignore
export default compose(
    withRouter,
    withTheme,
    withStyles(styles)
)(NotificationsPopover);
